import { render, staticRenderFns } from "./nav-datasource.vue?vue&type=template&id=716cef4e&"
import script from "./nav-datasource.vue?vue&type=script&lang=ts&"
export * from "./nav-datasource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports